import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, Grid, LL_H_C, ModuleFE_Thunderstorm, ModuleFE_Toaster, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { __stringify, MimeType_txt } from '@nu-art/ts-common';
import { ViewKey_Edit, ViewKey_View } from '../../../../consts.js';
import { QScrollWrapper } from '@app/hcs-frontend';
import { Editor_FHIRConfig } from './Editor_FHIRConfig/Editor_FHIRConfig.js';
import { Editor_DeployConfig } from './Editor_DeployConfig/Editor_DeployConfig.js';
import { TS_EditableItemComponentProto } from '@nu-art/thunderstorm-frontend/editable-item';
import { ModuleFE_EHRInstallation } from '../../../../../../_entity/installation/ehr-installation/index.js';
import { ModuleFE_Environment } from '../../../../../../_entity/installation/environment/index.js';
export class Editor_EnvironmentConfig extends TS_EditableItemComponentProto {
    // TODO: add the KB version dispatcher
    // implements DispatcherInterface<DispatcherType_EHRInstanceKBVersion>
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.editMode = nextProps.editMode;
        return state;
    }
    // ######################## Logic ########################
    getViewMode = () => this.state.editMode ? ViewKey_Edit : ViewKey_View;
    // ######################## Render ########################
    render() {
        return _jsx(LL_H_C, { id: 'editor-organization-ehr-instances', children: this.renderForm() });
    }
    // ######################## Render - EHR Instances Editor ########################
    renderForm = () => {
        if (!this.state.editable)
            return _jsx(_Fragment, {});
        const className = _className(this.state.editMode && 'edit-mode');
        return (_jsx("div", { className: "form-wrapper", children: _jsx(QScrollWrapper, { children: _jsxs(Grid, { className: className, children: [this.renderSaveButton(), this.renderConfigEditor(), this.renderFHIRConfig_Generated()] }) }) }));
    };
    renderConfigEditor = () => {
        switch (this.state.editable.get('type')) {
            case 'epic':
                return _jsx(Editor_FHIRConfig, { editable: this.state.editable.editProp('authInterfaceProfile', {}), mode: this.getViewMode() });
            case 'cerner':
                return _jsx("div", { children: "Cerner is not supported ATM" });
            case 'deploy':
                return _jsx(Editor_DeployConfig, { editable: this.state.editable.editProp('authInterfaceProfile', {}), mode: this.getViewMode() });
        }
    };
    renderSaveButton = () => {
        const editable = this.state.editable;
        if (!editable || editable?.item._id)
            return;
        return _jsx("div", { children: _jsx(Button, { variant: 'primary', onClick: async () => {
                    try {
                        await editable?.save();
                    }
                    catch (err) {
                        this.logError(err);
                        this.forceUpdate();
                    }
                }, children: "Save" }) });
    };
    renderFHIRConfig_Generated = () => {
        const environment = this.state.editable.item;
        if (!environment._id || environment.type !== 'epic')
            return;
        const config = environment.authInterfaceProfile;
        const pathToCert = config.secretPaths?.cert;
        const publicKey = config.publicKey;
        return _jsxs(TS_PropRenderer.Flat, { label: 'Generated FHIR Config', className: 'span-row', children: [_jsx(TS_PropRenderer.Flat, { label: 'Cert', className: 'indent', children: _jsxs("div", { className: 'grid-data', children: ["Click to copy ", _jsx("span", { className: 'grid-data-link', onClick: async () => {
                                    if (!pathToCert) {
                                        ModuleFE_Toaster.toastError('Could not find config for cert. Please validate your FHIR config.');
                                        return;
                                    }
                                    const installation = ModuleFE_EHRInstallation.cache.unique(environment.ehrInstallationId);
                                    if (!installation) {
                                        ModuleFE_Toaster.toastError(`Just tried to get a cert for an environment with no installation, Please validate ${environment.label}.`);
                                        return;
                                    }
                                    const certContent = await ModuleFE_Environment._v1.getCertData({ environmentId: environment._id }).executeSync();
                                    return ModuleFE_Thunderstorm.downloadFile({
                                        fileName: `Certificate - ${installation.label} - ${environment.label}`,
                                        mimeType: MimeType_txt,
                                        content: __stringify(certContent)
                                    });
                                }, children: "Cert" })] }) }), _jsx(TS_PropRenderer.Flat, { label: 'Public Key', className: 'indent', children: _jsxs("div", { className: 'grid-data', children: ["Click to download ", _jsx("span", { className: 'grid-data-link', onClick: () => {
                                    if (!publicKey) {
                                        ModuleFE_Toaster.toastError('Public key is missing for this environment.');
                                        return;
                                    }
                                    return ModuleFE_Thunderstorm.copyToClipboard(publicKey);
                                }, children: "Public Key" })] }) })] });
    };
}
//# sourceMappingURL=Editor_EnvironmentConfig.js.map